/**
 * Single source of truth for the public site origin.
 * Update here when changing primary domains.
 */
export const SITE_URL = "https://www.babblegram.app";
export const SITE_NAME = "BabbleGram";
